import type { AdditionalFilterValues } from "@bbj-types/candidate";
import { AdditionalField } from "@complex/FilterCandidateSchemas";
import {
  type TAdditionalFilterOption,
  type TExtendedAddtionalFiltersValues,
  isCandidateSchemaFilterOption,
} from "@complex/ModalSelectCandidates/filters/additionalFilters/logics";
export interface IExtendedCandidateAdditionalField {
  option: TAdditionalFilterOption;
  onChangeAdditionalField: (value: AdditionalFilterValues | null) => void;
  onChangeExtendedField: (value: TExtendedAddtionalFiltersValues) => void;
  additionnalFieldValue: AdditionalFilterValues | null;
  extendedFieldValue: TExtendedAddtionalFiltersValues;
}
import { AutocompletePlaces } from "@inputs/autocomplete/AutocompletePlacesUniq";
import { Box, TextField } from "@mui/material";

export const ExtendedCandidateAdditionalField = ({
  option,
  onChangeAdditionalField,
  onChangeExtendedField,
  additionnalFieldValue,
  extendedFieldValue,
}: IExtendedCandidateAdditionalField) => {
  if (isCandidateSchemaFilterOption(option)) {
    return <AdditionalField fieldSchema={option} onChange={onChangeAdditionalField} value={additionnalFieldValue} />;
  }
  switch (option.value) {
    case "place":
      return (
        <AutocompletePlaces
          disableCloseOnSelect
          value={extendedFieldValue}
          onChange={(_event, value) => value && Array.isArray(value) && onChangeExtendedField(value)}
          size="small"
          limitTags={1}
          sx={{ minWidth: 0 }}
          multiple
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <Box
                  sx={{
                    pr: 0.5,
                  }}
                >
                  {option.label}
                </Box>
              }
            />
          )}
          ChipProps={{
            color: "yellow",
            size: "small",
          }}
          fullWidth
        />
      );
  }
  return null;
};
